<template>
  <div>
    <el-form label-width="100px">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="操作类型">
            <el-select
              v-model="searchForm.type"
              clearable
              placeholder="操作类型"
              class="cus_width"
            >
              <el-option
                v-for="item in RecordOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-button @click="getConfig" type="success">搜索</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
    >
      <el-table-column
        label="ID"
        align="center"
        prop="id"
        width="100"
      ></el-table-column>

      <el-table-column
        label="类型"
        align="center"
        prop="updateTime"
        width="160"
      >
        <template slot-scope="{ row }">
          {{ getLabelByValue(row.type) }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作关联ID"
        align="center"
        prop="relevancyId"
        width="160"
      ></el-table-column>
      <el-table-column
        label="备注"
        align="center"
        prop="remark"
        min-width="160"
      ></el-table-column>
      <el-table-column
        label="操作用户"
        align="center"
        prop="nickName"
        width="200"
      ></el-table-column>
      <el-table-column
        label="操作时间"
        align="center"
        width="180"
        prop="createTime"
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  name: "log",
  data() {
    return {
      searchForm: {
        type: "",
        pageNo: 1,
        pageSize: 10,
      },
      tableData: [],
      multipleSelection: [],
      total: 0,

      RecordOptions: [
        {
          label: "分配权限",
          value: 23,
        },
        {
          label: "用户数据导出",
          value: 29,
        },
        {
          label: "后台用户充值",
          value: 14,
        },
        {
          label: "提现后台审核",
          value: 15,
        },
        {
          label: "沟通记录",
          value: 21,
        },
        {
          label: "文章变动",
          value: 19,
        },
        {
          label: "技术问答",
          value: 22,
        },
        {
          label: "积分变动",
          value: 27,
        },
        {
          label: "折扣变动",
          value: 8,
        },
        {
          label: "创建达人",
          value: 16,
        },
        {
          label: "达人变动",
          value: 17,
        },
        {
          label: "添加优惠卷",
          value: 28,
        },
        {
          label: "优惠券上架",
          value: 4,
        },
        {
          label: "优惠券下架",
          value: 5,
        },
        {
          label: "优惠券赠送",
          value: 6,
        },
        {
          label: "添加商品",
          value: 26,
        },
        {
          label: "添加拼团商品",
          value: 24,
        },
        {
          label: "添加秒杀商品",
          value: 25,
        },
        {
          label: "商品上架",
          value: 1,
        },
        {
          label: "商品下架",
          value: 2,
        },
        {
          label: "调拨变动",
          value: 9,
        },
        {
          label: "手动发货",
          value: 12,
        },
        {
          label: "财务订单导出",
          value: 10,
        },
        {
          label: "达人拣货清单导出",
          value: 11,
        },
        {
          label: "订单数据导出",
          value: 13,
        },
        {
          label: "仓库商品库存修改",
          value: 30,
        },
         {
          label: "订单退款",
          value: 31,
        },
      ],
    };
  },
  created() {
    this.getConfig();
  },
  methods: {
    getLabelByValue(value) {
      if (!this.RecordOptions || !Array.isArray(this.RecordOptions)) return "";
      const item = this.RecordOptions.find((item) => item.value === value);
      return item ? item.label : "";
    },
    getConfig() {
      this.$axios
        .post("/admin/operationRecord/getList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    handleSizeChange(i) {
      this.searchForm.pageSize = i;
      this.getConfig();
    },

    handleCurrentChange(i) {
      this.searchForm.pageNo = i;
      this.getConfig();
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
